$(document).ready(function(){
    var nav = $('header .desctop nav');
    
    nav.find('> ul > li > a').click(function(event){ 
        var popup = $(this).closest('li').find('> ul');
        if(popup.length > 0) {
            event.preventDefault();
            nav.find('> ul > li > ul').hide();            
            popup.show();           
        }        
    });
    
    nav.find('> ul > li > ul').mouseleave(function() {
        $(this).hide();
    });
    
    nav.find('> ul > li > ul').each(function() {
        var popup = $(this);
        if(popup.find('a').length > 20) {
            popup.addClass('long');
        }        
    });    
});
